
    import React from 'react';
    import { Outlet } from 'react-router-dom';
    import Header from '@/components/Header';
    import Footer from '@/components/Footer';
    import EmailConfirmationBanner from '@/components/EmailConfirmationBanner';

    const Layout = () => {
      return (
        <div className="flex flex-col min-h-screen bg-background text-foreground">
          <Header />
          <EmailConfirmationBanner />
          <main className="container flex-grow px-4 py-8 mx-auto"> 
            <Outlet />
          </main>
          <Footer />
        </div>
      );
    };

    export default Layout;
  